import { ABBaseComponent, defineComponent } from './ab-base-component.js';

class ABExpandText extends ABBaseComponent {
  connectedCallback() {
    this.content = this.$('[data-expand-content]');
    this.toggle = this.$('[data-expand-toggle]');
    this.labelMore = this.$('[data-expand-label-more]');
    this.labelLess = this.$('[data-expand-label-less]');
    this.maxHeight = parseInt(this.dataset.maxHeight || '120', 10);

    if (!this.content || !this.toggle) return;

    // Wait for render to measure content height
    requestAnimationFrame(() => this._init());
  }

  _init() {
    const naturalHeight = this.content.scrollHeight;
    if (naturalHeight <= this.maxHeight) return;

    // Content exceeds threshold — enable collapse
    this.content.style.maxHeight = `${this.maxHeight}px`;
    this.setAttribute('data-collapsed', '');
    this.toggle.hidden = false;
    this._collapsed = true;

    this.toggle.addEventListener('click', () => this._toggle(naturalHeight));
  }

  _toggle(naturalHeight) {
    this._collapsed = !this._collapsed;

    if (this._collapsed) {
      this.content.style.maxHeight = `${this.maxHeight}px`;
      this.setAttribute('data-collapsed', '');
    } else {
      this.content.style.maxHeight = `${naturalHeight}px`;
      this.removeAttribute('data-collapsed');
    }

    this.labelMore.hidden = !this._collapsed;
    this.labelLess.hidden = this._collapsed;
  }
}

defineComponent('ab-expand-text', ABExpandText);
